<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <div class="score">{{ score }}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'RedEnvelope',
  data() {
    return {
      score: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getDetail(val);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getDetail(uuid) {
      try {
        const res = await this.$http.get(
          `https://devops.nicee.app/api/hongbao/score/${uuid}`
        );
        if (res) {
          this.score = res.score;
        }
      } catch (error) {
        this.score = 0;
        console.log(error);
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #010119;
  background-image: url('./images/web-bg.jpg');
  background-size: 100% 100%;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 750px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .score {
      position: absolute;
      top: 1724px;
      left: 454px;
      color: #c84b3e;
      width: 208px;
      text-align: center;
      font-size: 54px;
      font-weight: bold;
    }
  }
}
</style>
